import React from 'react';
import styled from 'styled-components';

import SkeletonBox from '../../../SkeletonBox';

import type { DynamicDataBlockProps } from './types';

const DynamicDataBlock = ({
  icon,
  text,
  isMobile,
  order,
  isLoading = false,
}: DynamicDataBlockProps): JSX.Element =>
  !isLoading ? (
    <Container $order={order} $isMobile={isMobile}>
      {icon && <IconContainer $isMobile={isMobile}>{icon}</IconContainer>}
      <TextContainer>{text}</TextContainer>
    </Container>
  ) : (
    <Container $order={order} $isMobile={isMobile}>
      <SkeletonIcon />
      <SkeletonParagraph>
        <SkeletonTextFirst />
        <SkeletonTextSecond />
      </SkeletonParagraph>
    </Container>
  );

const IconContainer = styled.div<{ $isMobile: boolean }>`
  ${({ $isMobile }) =>
    $isMobile
      ? `
    height: 24px;
    width: 24px;
  `
      : `
    height: 30px;
    width: 30px;
  `}
`;

const TextContainer = styled.p`
  white-space: pre-line;
`;

const Container = styled.div<{ $isMobile: boolean; $order: number }>`
  display: flex;
  z-index: inherit;

  font-size: var(--small-text-size);

  & > * + * {
    margin-left: 0.334em;
  }

  order: ${({ $order }) => $order};

  ${({ $isMobile }) =>
    $isMobile
      ? `
        width: 100%;
        `
      : `
        width: 180px;
      `}

  ${({ $isMobile, $order }) =>
    !$isMobile &&
    $order === 1 &&
    `
    width: 300px;
  `}
`;

const SkeletonIcon = styled(SkeletonBox)`
  width: 2em;
  height: 2em;
  opacity: 0.5;
`;

const SkeletonTextFirst = styled(SkeletonBox)`
  width: 70%;
  height: 1em;
  opacity: 0.5;
`;

const SkeletonTextSecond = styled(SkeletonBox)`
  width: 90%;
  height: 1em;
  opacity: 0.5;
`;

const SkeletonParagraph = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  & > * + * {
    margin-top: 0.17em;
  }
`;
export default DynamicDataBlock;
